export const outgoingDirection = ['ALB-ALB', 'ALB-MNE', 'ALB-KSV', 'ALB-GRE']

export const ingoingDirection = ['ALB-ALB', 'MNE-ALB', 'KSV-ALB', 'GRE-ALB']

export default ['ALB-ALB', 'ALB-MNE', 'MNE-ALB', 'ALB-KSV', 'KSV-ALB', 'ALB-GRE', 'GRE-ALB']
